import React from 'react'
import { makeStyles, createStyles, theme } from '@material-ui/core/styles'
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(2),
            textAlign: 'center',
            color: theme.palette.text.secondary,
        },
        main: {
            backgroundColor: '#f1f1f1',
            padding: '20px',
            float: 'left',
            textAlign: 'left',
            fontSize: '16px',
            fontFamily: 'Times New Roman',
            color: 'black',
            //   width: "60%",
        },
        heading: {
            textAlign: 'center',
            fontFamily: 'Times New Roman',
            fontWeight: 'bold',
            color: 'black',
        },
        text: { fontSize: '16px', fontFamily: 'Times New Roman', color: 'black' },
    }),
)

export default function IotrixDisclaimerAndroid() {
    const classes = useStyles()
    return (
        <>
            <div className={classes.root}>
                <Grid container spacing={1}>
                    <Grid item xs={1} sm={2} md={2} lg={3}>
                        {/* <Paper className={classes.paper}>xs=3</Paper> */}
                    </Grid>
                    <Grid item xs={10} sm={8} md={8} lg={6}>
                        <Paper className={classes.main}>
                            <h1 className={classes.heading} style={{ fontSize: 33 }}>
                                <b>Software End User Licence Agreement</b>
                            </h1>
                            <h2 className={classes.heading} style={{ fontSize: '23px' }}>
                                <b> "GetLevel IOTRIX" ANDROID Version </b>
                            </h2>
                            <Typography className={classes.text}>
                                Read the following terms and conditions carefully before
                                downloading,installing or using this software (defined below).
                                Filling in the space next to "I accept the terms in the License
                                Agreement" indicates your acceptance of these terms and
                                conditions. If you do not agree with such terms and
                                conditions,click "Cancel".This Software is available only to
                                individuals aged 13 years or older.if you are 13 or older but
                                under the age of 18,you should review these terms and conditions
                                with your parent or guardian to make sure that you and your
                                parent or guardian understand these terms and conditions.
                            </Typography>
                            <br />
                            <h2 className={classes.heading} style={{ fontSize: '23px' }}>
                                LICENSE
                            </h2>
                            <Typography className={classes.text}>
                            Welcome to GetLevel! This privacy policy outlines how we collect, use, and protect your personal data when you use our app. By using GetLevel, you agree to the terms of this Privacy Policy.
                            </Typography>
                            <ol>
                                <li><b>Information We Collect</b><br/>
                                We collect the following types of information:
                                <ul>
                                    <li><b>Personal Information : </b> Name, email, phone number (if provided by the user).</li>
                                    <li><b>Device Information : </b> IP address, device model, operating system version.</li>
                                    <li><b>Usage Data : </b> App activity, interactions, and preferences.</li>
                                </ul>
                                </li>
                                <br />
                                <li><b>How We Use the Information</b><br/>
                                We use the collected data for:
                                <ul>
                                    <li>Providing and improving app functionality.</li>
                                    <li>Enhancing user experience and support.</li>
                                    <li>Sending important updates and notifications.</li>
                                </ul>
                                </li>
                                <br />
                                <li><b>Data Sharing and Disclosure</b><br/>
                                We do not sell or trade user data. However, we may share information:
                                <ul>
                                    <li>With third-party service providers for analytics and cloud storage.</li>
                                    <li>When required by law or to protect our rights and users.</li>
                                </ul>
                                </li>
                                <br />
                                <li><b>Security Measures </b><br/>
                                    We implement industry-standard security practices to protect user data, including encryption and access restrictions.
                                </li>
                                <br />
                                <li><b>User Rights and ControlsUsers have the right to:</b><br/>
                                    Access, update, or delete their data.
                                    Opt-out of data collection features where applicable.
                                    Contact us for any privacy-related concerns.
                                </li>
                                <br />
                                <li><b>Third-Party Services</b><br/>
                                GetLevel may use third-party services like Google Analytics or Firebase, which have their own privacy policies. We encourage users to review them.
                                </li>
                                <br />
                                <li><b>Children's Privacy</b><br/> 
                                Our app is not intended for children under 13. We do not knowingly collect data from minors. If you believe a child has provided data, contact us for removal.
                                </li>
                                <br />
                                <li>
                                 <b>Policy Updates</b> <br/>
                                 We may update this Privacy Policy periodically. Users will be notified of significant changes through the app or email.
                                </li>
                                <br />
                                <li><b>Contact Information</b><br/> 
                                For any questions or concerns regarding this Privacy Policy, contact us at:
                                <ul>
                                    <li><b>Company Name: </b> IoTrix Solution Private Limited</li>
                                    <li><b>Email: </b> iotrix.banking@gmail.com</li>
                                    <li><b>Website:</b> <a href={"https://iotrix.in"}>https://iotrix.in</a></li>
                                </ul>
                                </li>
                                <br />
                            </ol>
                        </Paper>
                    </Grid>
                    <Grid item xs={1} sm={2} md={2} lg={3}>
                        {/* <Paper className={classes.paper}>xs=3</Paper> */}
                    </Grid>
                </Grid>
            </div>
        </>
    )
}
